import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function NewTitleDialog({ open, onOpenChange, onCreate, colors }) {
  const [name, setName] = useState("");
  const [color, setColor] = useState(colors?.[0] || "#2563EB");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setName("");
      setColor(colors?.[0] || "#2563EB");
    }
  }, [open, colors]);

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!name.trim() || busy) return;
    setBusy(true);
    try {
      await onCreate(name.trim(), color);
      onOpenChange(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121212] border-[#27272A] text-[#F3F4F6]">
        <DialogHeader>
          <DialogTitle className="font-heading">New title</DialogTitle>
          <DialogDescription className="text-[#9CA3AF]">
            A title is a topical thread for grouping links and notes.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs text-[#9CA3AF]">Name</Label>
            <Input
              autoFocus
              data-testid="new-title-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. React Notes, Travel Ideas"
              className="bg-[#1E1E1E] border-[#27272A] rounded-xl h-11"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-xs text-[#9CA3AF]">Color</Label>
            <div className="flex flex-wrap gap-2">
              {colors.map((c) => (
                <button
                  key={c}
                  type="button"
                  data-testid={`color-swatch-${c}`}
                  onClick={() => setColor(c)}
                  className={`h-8 w-8 rounded-full transition-all ${
                    color === c ? "ring-2 ring-offset-2 ring-offset-[#121212] ring-[#F3F4F6]" : ""
                  }`}
                  style={{ background: c }}
                  aria-label={`Color ${c}`}
                />
              ))}
            </div>
          </div>
          <DialogFooter className="gap-2">
            <Button
              type="button"
              onClick={() => onOpenChange(false)}
              variant="ghost"
              className="rounded-full text-[#9CA3AF] hover:text-[#F3F4F6] hover:bg-[#1E1E1E]"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              data-testid="create-title-submit-btn"
              disabled={!name.trim() || busy}
              className="rounded-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white"
            >
              {busy ? "Creating…" : "Create"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
